<script>
import ItemComponent from './Item.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    module: Object,
  },
  methods: {
    getHref(item) {
      return `/tourclient/admin/orders/info.html?code=${item.AgreementCode}`;
    },
    hide(item) {
      this.module.hide(item);
    },
    open(item) {
      this.module.open = item;
    },
  },
};
</script>
<template>
  <div v-if="module.show">
    <v-list
      max-width="460px"
      min-width="460px"
      class="pa-0"
      style="background: none"
    >
      <v-sheet
        v-for="item in module.itemsMin.slice(0, 5)"
        :key="item.ID"
        :elevation="6"
        class="ma-3"
      >
        <ItemComponent
          :item="item"
          @open="open(item)"
          @close="hide(item)"
        />
      </v-sheet>
    </v-list>
  </div>
</template>
<style lang="scss">

</style>
